import UnstyledAccordion from '@mui/material/Accordion'
import UnstyledAccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import styled from 'styled-components'

import UnstyledIconLink from './IconLink'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-around;
  text-align: center;
  align-items: flex-end;
`

const Description = styled.strong`
  display: block;
  color: #333333;
  font-size: 10px;
  font-weight: normal;
  text-transform: uppercase;
`

const AllTypography = styled.strong`
  margin-bottom: 2px;
  display: block;
  color: #68504c;
  font-size: 24px;
  text-transform: uppercase;
`

const Accordion = styled(UnstyledAccordion)`
  z-index: ${props => props.theme.zIndex.dropdown};
  box-shadow: unset;
  background-color: #f2f0ed;
  position: absolute;
  width: 100%;
  top: 90px;

  &.Mui-expanded {
    margin: 0;
  }
`

const AccordionDetails = styled(UnstyledAccordionDetails)`
  border-bottom: 3px solid #68504c;
`

const IconLink = styled(UnstyledIconLink)`
  font-size: 28px;

  strong {
    font-size: 10px;
    font-weight: normal;
    text-transform: uppercase;
  }
`

const ItemsForSale = ({ expanded }) => {
  return (
    <Accordion expanded={expanded}>
      <AccordionSummary sx={{ display: 'none' }}></AccordionSummary>
      <AccordionDetails>
        <Wrapper>
          <IconLink
            id='ifs_construction'
            font="'\e801'"
            label='Const.'
            path='/search/?filters=industry_category_id%3A1'
          />
          <IconLink
            id='ifs_ag-equipment'
            font="'\e802'"
            label='Ag. Equip'
            path='/search/?filters=industry_category_id%3A151'
          />
          <IconLink
            id='ifs_truck-trailer'
            font="'\e803'"
            label='Truck/Trailer'
            path='/search/?filters=industry_category_id%3A256%2C229'
          />
          <IconLink
            id='ifs_passenger-vehicles'
            font="'\e804'"
            label='Passenger'
            path='/search/?filters=industry_category_id%3A277'
          />
          <a
            id='header_all_items'
            href='/search'
            style={{ textDecoration: 'none' }}
          >
            <AllTypography>All</AllTypography>
            <Description>Items</Description>
          </a>
        </Wrapper>
      </AccordionDetails>
    </Accordion>
  )
}

export default ItemsForSale
